import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate";

import axios from '../plugins/axios';

import auth from './modules/auth'
import user from './modules/user'
import menu from './modules/menu'
import cont from './modules/cont'
import orders from './modules/orders'
import vehicles from './modules/vehicles'
import profiles from './modules/profiles'
import countries from './modules/countries'
import counties from './modules/counties'
import categories from './modules/categories'
import vignetteCategories from './modules/vignetteCategories'
import tollCategories from './modules/tollCategories'
import cart from './modules/cart'
import language from './modules/language'
import payuTokens from './modules/payuTokens'
import header from './modules/header'
import faq from './modules/faq'
import loading from './modules/loading'
import ordersStatus from "./modules/ordersStatus"
import settings from "./modules/settings"
import recaptcha from "./modules/recaptcha"


const store = new Vuex.Store({
    plugins: [createPersistedState({
        key: 'untrr',
        paths: ['auth', 'user', 'cart', 'language', 'profiles.manualProfileCompletion'],
        storage: {
            getItem: (key) => localStorage.getItem(key),
            setItem: function(key, value)  {
                localStorage.setItem(key, value);
            },
            removeItem: (key) => localStorage.removeItem(key),
        },
    })],
    modules: {
        auth,
        user,
        menu,
        cont,
        orders,
        language,
        vehicles,
        profiles,
        countries,
        counties,
        categories,
        vignetteCategories,
        tollCategories,
        cart,
        payuTokens,
        header,
        faq,
        loading,
        ordersStatus,
        settings,
        recaptcha
    },
    state: {
    },
    mutations: {
    },
    getters: {
         backLink: (state, getters) => {
             if(state.cart.length) {
                 var last_element_in_cart = state.cart[state.cart.length - 1];
                 if (last_element_in_cart.type == "toll") {
                      return "toll";
                 }
                 else {
                      return "vignette";
                 }
             }
             else {
                 return "vignette";
             }
         }
    },
    computed: {
    }
});

store.$axios = axios;

export default store;
